import { motion, useReducedMotion } from 'motion/react';

import DefaultLink from 'components/common/DefaultLink';

const SatisfactionGuaranteed = ({ data }) => {
  const { text, linkText, linkUrl } = data;

  const prefersReducedMotion = useReducedMotion();

  return (
    <section className="flex flex-col items-center gap-2 bg-white-110 px-4 pb-10 pt-8">
      <motion.div
        className="flex w-full max-w-7xl justify-center gap-2 rounded-xl bg-family-beige-100 px-4 py-6"
        initial={{ opacity: 0, y: prefersReducedMotion ? 0 : 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, type: 'spring' }}
        viewport={{ once: true, amount: 0.5 }}
      >
        <p className="textMd bp2:h5 text-center text-green-140">
          {text}{' '}
          <DefaultLink to={linkUrl} isExternal className="textMd bp2:h5 text-green-140">
            {linkText}
          </DefaultLink>
        </p>
      </motion.div>
    </section>
  );
};

SatisfactionGuaranteed.propTypes = {
  data: PropTypes.shape({
    text: PropTypes.string.isRequired,
    linkText: PropTypes.string.isRequired,
    linkUrl: PropTypes.string.isRequired,
  }).isRequired,
};

export default SatisfactionGuaranteed;
